import { render } from "./TipsSwitch.vue?vue&type=template&id=4f2184ee&scoped=true"
import script from "./TipsSwitch.vue?vue&type=script&lang=js"
export * from "./TipsSwitch.vue?vue&type=script&lang=js"

import "./TipsSwitch.vue?vue&type=style&index=0&id=4f2184ee&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2184ee"]])

export default __exports__